const features = [
  {
    icon: "ri-stack-line",
    title: "海量正版资源",
    description: "与韩国多家顶级漫画出版社合作，收录超过5000部正版韩漫作品，涵盖所有主流类型，资源丰富度行业领先。",
  },
  {
    icon: "ri-4k-line",
    title: "高清画质体验",
    description: "所有漫画均提供高清分辨率，完美适配手机、平板和电脑等多种设备，带来沉浸式的视觉享受。",
  },
  {
    icon: "ri-flashlight-line",
    title: "极速同步更新",
    description: "与韩国平台保持同步更新，热门漫画每周更新1-2话，专业的汉化团队确保第一时间呈现优质翻译。",
  },
  {
    icon: "ri-smartphone-line",
    title: "全设备适配",
    description: "响应式设计完美支持各类设备，无论是在通勤路上还是家中沙发，都能畅享丝滑的阅读体验。",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全无广告",
    description: "干净清爽的阅读环境，没有任何弹窗广告和恶意跳转，让您专注于漫画本身的精彩世界。",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "智能推荐系统",
    description: "基于您的阅读偏好，精准推荐感兴趣的漫画作品，让好作品主动找到您，发现更多惊喜。",
  },
];

export default function FeatureGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-xs text-foreground-400 uppercase tracking-wider mb-2">
            为什么选择我们
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 leading-tight"
            style={{ fontFamily: "var(--font-heading)" }}>
            韩漫网的<span className="text-accent-500">核心优势</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 rounded-lg p-5 md:p-6"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-background-100 mb-4">
                <i className={`${feat.icon} text-xl text-foreground-700`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 whitespace-nowrap">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}